export class QuerySubCategoryModel
{
    Sub_Cat_Code : string='';
    Clarification_Cat_Code : string='';
    SubCatDesc : string='';
}